import jilUserGroups from 'api/jil/jilUserGroups';
import OrganizationUser from 'models/organizationUser/OrganizationUser';
import feature from 'services/feature';
import log from 'services/log';
import MemberList from 'services/member/MemberList';

class UserGroupUserList extends MemberList {
  /**
   * @description Method to retrieve an existing UserGroupUserList from the back-end.
   * @deprecated Remove with temp_src2_cache
   *
   * @param {String} options.userGroupId - The user group id
   * @param any other MemberList or JilModelList option
   *
   * @returns {Promise} Promise that resolves to the instance when the refresh is successful
   */
  static get(options) {
    if (feature.isEnabled('temp_src2_cache')) {
      return super.get(options);
    }
    // This should be cached once a caching scheme is worked out and the /src version of this
    // API is no longer in use.
    const model = new UserGroupUserList(options);
    return model.refresh();
  }

  /**
   * @description Constructor for UserGroupUserList model Objects.
   *
   * @param {Object} options - See MemberList for additional options
   * @param {String} options.userGroupId - The user group id
   * @param any other MemberList or JilModelList option
   */
  constructor(options) {
    super({
      itemClassRef: OrganizationUser,
      modelCacheId: 'UserGroupUserList',
      refreshResource: jilUserGroups.getUserGroupUsersList,
      saveResource: jilUserGroups.patchUserGroupUsers,
      ...options,
    });
    this.userGroupId = options.userGroupId;
  }

  /**
   * @description Get params for api call to fetch list.
   *
   * @returns {Object} params to be passed to query
   */
  getQueryParams() {
    return {
      ...super.getQueryParams(),
      userGroupId: this.userGroupId,
    };
  }

  /**
   * @description Method to refresh the contents of the user group admin list
   * @deprecated Remove with temp_src2_cache
   *
   * @returns {Promise} promise - resolved when the list is refreshed
   */
  async refresh() {
    if (feature.isEnabled('temp_src2_cache')) {
      return super.refresh();
    }

    try {
      await super.refresh({orgId: this.orgId, userGroupId: this.userGroupId});
    } catch (error) {
      log.error('UserGroupUserList failed to load. Error: ', error);
      return Promise.reject(error);
    }

    return this;
  }

  /**
   * If this is needed, in the constructor, set saveResource to jilUserGroups.patchUserGroupUsers
   * and implement this.
   */
  save() {
    if (this.addedItems.length > 0) {
      throw new Error('UserGroupUserList.save is not implemented for addedItems');
    }

    return super.save(
      {
        userGroupId: this.userGroupId,
      },
      {
        refresh: false,
      }
    );
  }
}

export default UserGroupUserList;
